import { render, staticRenderFns } from "./AddCarServicerInfo.vue?vue&type=template&id=cdb5ef28&scoped=true"
import script from "./AddCarServicerInfo.vue?vue&type=script&lang=js"
export * from "./AddCarServicerInfo.vue?vue&type=script&lang=js"
import style0 from "./AddCarServicerInfo.vue?vue&type=style&index=0&id=cdb5ef28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb5ef28",
  null
  
)

export default component.exports